import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
} from 'react';

const ModalStackContext = createContext();

export const useModalStack = () => useContext(ModalStackContext);

export const ModalStackProvider = ({ children }) => {
  const [stack, setStack] = useState([]);

  const pushModal = useCallback((modal) => {
    setStack((prev) => [...prev, modal]);
  }, []);

  const popModal = useCallback(() => {
    setStack((prev) => {
      const newStack = prev.slice(0, -1);
      return newStack;
    });
  }, []);

  const wipeStack = useCallback(() => {
    setStack([]);
  }, []);

  const contextValue = useMemo(
    () => ({
      pushModal,
      popModal,
      wipeStack,
    }),
    [pushModal, popModal, wipeStack]
  );

  return (
    <ModalStackContext.Provider value={contextValue}>
      {children}
      {stack.map((modal, index) => {
        const ModalComponent = modal.component;
        const modalProps = modal.props || {};
        return (
          <div
            key={index}
            style={{
              zIndex: 1000 + index,
            }}
          >
            <ModalComponent
              {...modalProps}
              isModalOpen={index === stack.length - 1}
            />
          </div>
        );
      })}
    </ModalStackContext.Provider>
  );
};
